import React, { Fragment, useEffect, useRef, useState } from 'react'
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { convertToHTML, convertFromHTML } from 'draft-convert';
import PropTypes from "prop-types"

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


const FormEditors = ({ content, setEditedContent }) => {
    const [editorState, setEditorState] = useState(
        () => EditorState.createEmpty(),
    );

    // This ref prevents the content useEffect from resetting
    // the editor state (and cursor position) after every keystroke.
    const isInternalChange = useRef(false);

    const handleEditorChange = (state) => {
        isInternalChange.current = true;
        setEditorState(state);
        // Pass the latest state directly instead of using stale closure
        const currentContentAsHTML = convertToHTML(state.getCurrentContent());
        setEditedContent(currentContentAsHTML);
    }

    // Only re-initialize the editor when the `content` prop changes externally
    // (e.g. on first load, or tab switch). If the change came from typing,
    // skip the reset so the cursor stays in place.
    useEffect(() => {
        if (isInternalChange.current) {
            isInternalChange.current = false;
            return;
        }
        if (content) {
            setEditorState(EditorState.createWithContent(convertFromHTML(content)));
        }
    }, [content])


    return (
        <Fragment>
            <div className="db__column">
                <Editor
                    editorState={editorState}
                    onEditorStateChange={handleEditorChange}
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                />
            </div>

        </Fragment>
    );
};

export default FormEditors;

FormEditors.propTypes = {
    content: PropTypes.string,
    setEditedContent: PropTypes.func
}
